export default __webpack_public_path__ + "static/media/299.152a3529.gif";